import React from 'react';
import { useDispatch } from 'react-redux';
import { Alert, HeadingText } from '@swift-paypal/pp-react';
import UploadDocuments from '../../common/upload-documents/upload-documents';
import errors from '../../../constants/errors';
import { useShallowSelector } from '../../../hooks';
import documentUploadUtils from '../../../lib/document-upload-utils';
import { uploadDocumentsAction } from '../../../redux/actions/upload-document/upload-document-actions';
import {
  AllowedFileExtensions,
  AllowedSingleFileSize,
  HEADING_TEXT,
  UPLOAD_HELPER_TEXT,
} from './forgivenessGrossReceiptsDocuments.constants';
import { forgivenessGrossReceiptsDocumentsSelector } from './forgivenessGrossReceiptsDocuments.selectors';
import { ForgivenessGrossReceiptsDocumentsDetails } from './forgivenessGrossReceiptsDocumentsDetails';

export const ForgivenessGrossReceiptsDocuments = () => {
  const dispatch = useDispatch();
  const {
    hasServerError,
    stipulation,
  } = useShallowSelector(forgivenessGrossReceiptsDocumentsSelector);

  const handleSubmitDocumentUpload = (files) => {
    const payload = documentUploadUtils.buildMultipleFilesPayload(files, opportunityId, documentType);

    dispatch(uploadDocumentsAction(payload));
  };

  if (!stipulation) {
    return null;
  }

  const {
    opportunityId,
    stipulationMap: { documentType },
  } = stipulation;

  return (
    <>
      <HeadingText size="md">{HEADING_TEXT}</HeadingText>
      <ForgivenessGrossReceiptsDocumentsDetails />
      {hasServerError && <Alert className="margin-top-sm" type="error">{errors.technicalIssue}</Alert>}
      <UploadDocuments
        allowedFileExtensions={AllowedFileExtensions}
        helperText={UPLOAD_HELPER_TEXT}
        customClassName="increased-width"
        isForgivenessStipulation
        maximumPerFileSizeInBytes={AllowedSingleFileSize}
        maximumTotalSizeInBytes={AllowedSingleFileSize}
        submitFunc={handleSubmitDocumentUpload}
      />
    </>
  );
};
